import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ChainSettingsState,
  EnzymeRepository,
  PriceCompareRepository,
  RebalancingComponent,
  RebalancingRepository,
  RebalancingState,
  RebalancingStep,
  RebalancingStepsComponent,
  SettingsRepository,
} from 'common-rebalancing';
import { EnzymeVaultSelectionComponent } from './enzyme-vault-selection/enzyme-vault-selection.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-rebalance',
  standalone: true,
  imports: [
    CommonModule,
    RebalancingComponent,
    EnzymeVaultSelectionComponent,
    RebalancingStepsComponent,
    TranslateModule,
    NgIcon,
  ],
  templateUrl: './rebalance.component.html',
  styleUrls: ['./rebalance.component.css'],
})
export class RebalanceComponent {
  protected readonly RebalancingStep = RebalancingStep;

  constructor(
    private readonly enzymeRepository: EnzymeRepository,
    private readonly rebalancingRepository: RebalancingRepository,
    private readonly priceCompareRepository: PriceCompareRepository,
    private readonly settingsRepository: SettingsRepository,
  ) {}

  public get rebalancingState(): RebalancingState {
    return this.rebalancingRepository.store.getValue();
  }

  public get chainSettingState(): ChainSettingsState | undefined {
    return this.settingsRepository.getActiveChainSetting();
  }

  public onResetClick(): void {
    this.enzymeRepository.resetSelectedVault();
    this.rebalancingRepository.reset();
    this.priceCompareRepository.store.reset();
  }
}
